import React, { useState } from "react";
import "./DataSource.scss";
import PopupDataSource from "../../Popups/PopupDataSource";
import { MdAddCircleOutline, MdEdit, MdOutlineSave, MdDelete  } from "react-icons/md";


// Img
import arrowSelect from "../../assets/arrow-select.png";

const DataSource = (dashboardData) => {
  let datos = dashboardData;
  const initialData = datos.dashboardData.user.data_sources.map((source) => ({
    id: source._id,
    img: datos.dashboardData.parsers[source.source_type]?.logo || null,
    title: source.vehicle_name,
    subtitle: source.source_type,
    category: source.source_type.includes("Logger") ? "Logger" : "Camera",
  }));

  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("All sources");
  const [sortOrder, setSortOrder] = useState("vehicleAsc");
  const [data, setData] = useState(initialData);
  const [showDataSource, setShowDataSource] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const options = Object.keys(datos.dashboardData.parsers);

  const filteredData = data
    .filter(
      (item) =>
        (filter === "All sources" || item.subtitle === filter) &&
        (item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.subtitle.toLowerCase().includes(searchTerm.toLowerCase())),
    )
    .sort((a, b) =>
      sortOrder === "vehicleAsc"
        ? a.title.localeCompare(b.title)
        : b.title.localeCompare(a.title),
    );

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value;
    setFilter(selectedFilter);

    if (selectedFilter === "All sources") {
      setData(initialData);
    } else {
      const filtered = initialData.filter(
        (item) => item.subtitle.toLowerCase() === selectedFilter.toLowerCase(),
      );
      setData(filtered);
    }
  };

  const handleSortChange = (e) => {
    setSortOrder(e.target.value);
  };

  return (
    <div className="dataSource">
      <div className="dataSource-row">
        <h1>Data sources</h1>
        <h3>Manage your data sources</h3>
      </div>

      <div className="dataSource-row-table">
        <div className="table-dataSource">
          <div className="table-dataSource-controls">
            <div className="setting-datasource-search">
              <input
                type="text"
                placeholder="Search all data sources"
                value={searchTerm}
                onChange={handleSearch}
                className="dataSource-search"
              />
              <span className="icon-search"></span>
            </div>
            <div className="filter-sort-controls">
              <p>{filteredData.length} data sources</p>
              <div className="filter-contain">
                <div className="select-customizable">
                  <label>Filter by:</label>
                  <select
                    onChange={handleFilterChange}
                    value={filter}
                    className="filter-select"
                  >
                    <option value="All Sources">All sources</option>
                    {options.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <img
                    src={arrowSelect}
                    alt="arrowSelect"
                    className="select-arrow"
                  />
                </div>
                <div className="select-customizable">
                  <label>Sort by:</label>
                  <select
                    onChange={handleSortChange}
                    value={sortOrder}
                    className="sort-select"
                  >
                    <option value="vehicleAsc">Vehicle asc.</option>
                    <option value="vehicleDesc">Vehicle desc.</option>
                  </select>
                  <img
                    src={arrowSelect}
                    alt="arrowSelect"
                    className="select-arrow"
                  />
                </div>
                <div className="cont-btn">
                  <button className="btn btn-blue" onClick={() => {
                      setShowDataSource(true);
                      setPopupTitle("Add data source");
                    }}>
                    <MdAddCircleOutline size={22}/>
                    Add source
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="table-envolving-data-source">
            <table className="data-table">
              {filteredData.length > 0 ? (
                <tbody>
                  {filteredData.map((item) => (
                    <tr key={item.id} className="table-row-source">
                      <td className="img-cell">
                        <img
                          src={item.img}
                          alt={item.title}
                          className="table-img"
                        />
                      </td>
                      <td className="midlle-td">
                        <h3>{item.title}</h3>
                        <p>{item.subtitle}</p>
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            setShowDataSource(true);
                            setPopupTitle("Edit data source");
                            setSelectedData(item);
                          }}
                        >
                          <MdEdit size={22}/>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="center">
                  <tr>
                    <td className="noDataWhite">No data sources created</td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
      {/* Popup Generate Report */}
      {showDataSource && (
        <PopupDataSource
          datos={datos}
          selectedData={selectedData}
          onClose={() => setShowDataSource(false)}
          tit={popupTitle}
        />
      )}
    </div>
  );
};
export default DataSource;
